"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = exports.Item = exports.QuickAccess = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var QuickAccess = _styledComponents["default"].div.withConfig({
  displayName: "QuickAccessstyle__QuickAccess",
  componentId: "sc-1vkwqfn-0"
})(function (_ref) {
  var spacing = _ref.theme.spacing;
  return {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    height: spacing.inline['7xl'],
    overflow: 'hidden'
  };
});

exports.QuickAccess = QuickAccess;

var Item = _styledComponents["default"].a.withConfig({
  displayName: "QuickAccessstyle__Item",
  componentId: "sc-1vkwqfn-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return _extends({
    flex: '1 0',
    minWidth: '112px',
    boxSizing: 'border-box',
    transition: '0.1s',
    background: 'transparent',
    border: 'none',
    borderLeft: "1px solid ".concat(theme.color.line.medium),
    display: 'inline-block',
    textAlign: 'center',
    padding: theme.spacing.inline['6xs'],
    cursor: 'pointer',
    outline: 'none',
    textDecoration: 'none',
    color: theme.color.brandPrimary.light,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  }, (0, _utils.getTextStyle)({
    theme: theme,
    variant: 'caption-02',
    margin: false
  }), {
    ':first-child': {
      borderLeft: 'none'
    },
    ':hover': {
      color: theme.color.brandPrimary.medium
    }
  });
});

exports.Item = Item;

var Icon = _styledComponents["default"].svg.withConfig({
  displayName: "QuickAccessstyle__Icon",
  componentId: "sc-1vkwqfn-2"
})(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      color = _ref3$theme.color,
      spacing = _ref3$theme.spacing;
  return {
    display: 'block',
    width: spacing.inline.xs,
    height: spacing.inline.xs,
    margin: '0 auto 8px',
    fill: color.brandSecondary.dark
  };
});

exports.Icon = Icon;